import axios from 'axios';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { member as v_member, basic, Values, oper as v_oper, admin as v_admin } from '../request/values';

const SERVER = basic.server;

const useMember = () => {
	const history = useHistory();
	const getToken = () => {
		const memberString = localStorage.getItem('member');
		let memberToken;

		try {
			if (memberString) {
				memberToken = JSON.parse(memberString);
				console.log('memberToken? ', memberToken);
			}
		} catch (e: any) {
			console.error('JSON Parse error:', e.message);
			localStorage.removeItem('member');
			memberToken = null;
			history.push('/');
		}

		return memberToken;
	};

	const [member, setMember] = useState(getToken());

	const saveMember = (memberToken: any) => {
		console.log('in saveMember token ', memberToken);
		localStorage.setItem('member', JSON.stringify(memberToken));
		setMember(memberToken);
	};

	const deleteMember = () => {
		localStorage.removeItem('member');
		setMember(null);
	};

	const refreshCookie = async () => {
		let parsed: { id?: string; type?: string } | null = null;
		try {
			const memberNow = localStorage.getItem('member');
			if (!memberNow) return;
			parsed = JSON.parse(memberNow);
			if (!parsed?.id) return;

			let response;
			if (parsed.type === 'member') {
				response = await axios.post(SERVER + v_member.member + v_member.cookie_upd, { userId: parsed.id });
			} else if (parsed.type === 'oper') {
				response = await axios.post(SERVER + v_oper.oper + v_oper.cookie_upd, { userId: parsed.id });
			} else if (parsed.type === 'subAdmin') {
				response = await axios.post(SERVER + v_admin.admin + v_admin.cookie_upd, { userId: parsed.id });
			} else {
				//window.location.href = '/';
				return false;
			}
			if (response.data.code === Values.SUCCESS_CODE) {
				if (parsed.type === 'oper') {
					window.location.href = '/operation/company/list';
				}
				return true;
			} else {
				console.log('refreshCookie failed', response.data);
				localStorage.removeItem('member');
				window.location.href = parsed.type === 'oper' ? 'https://educator.youstarter.co.kr' : '/';
				return false;
			}
		} catch (e) {
			console.error('refreshCookie error', e);
			localStorage.removeItem('member');
			window.location.href = parsed?.type === 'oper' ? 'https://educator.youstarter.co.kr' : '/';
			return false;
		}
	};

	const fetchOperInfo = async () => {
		try {
			console.log('fetchOperInfo member', member);
			const response = await axios.get(SERVER + v_oper.oper + v_oper.info, {
				params: { userId: member.id },
				withCredentials: true,
			});
			const data = response.data;
			console.log('fetchOperInfo data', data);
			if (data.code === Values.SUCCESS_CODE) {
				setMember({
					...member,
					classCode: data.class_code,
				});
				localStorage.setItem('member', JSON.stringify({ ...member, classCode: data.class_code }));
				return;
			}
			return;
		} catch (e) {
			console.error('fetchOperInfo error', e);
			return;
		}
	};

	useEffect(() => {
		console.log('member is changed!', member);
		// saveMember(member)
	}, [member]);

	return {
		member,
		setMember: saveMember,
		deleteMember: deleteMember,
		refreshCookie,
		fetchOperInfo,
		// seveMember: saveMember,
	};
};

export default useMember;
